import { render } from "./DeclarationOfConsent.vue?vue&type=template&id=9a03187c"
import script from "./DeclarationOfConsent.vue?vue&type=script&lang=js"
export * from "./DeclarationOfConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__